import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { shareReplay } from "rxjs";
import { EstablishmentsForCategorieResponse } from "../../establishments-for-categorie/interface/establishments-for-categorie.interface";
import { NavigateEstablishment } from "../../../core/interfaces/navigate-for-categorie-establishment/navegiate-for-categorie.establishment.service";
import { AuthService } from "../../../core/service/auth.service";

@Injectable
  ({ providedIn: 'root' })

export class EstablishmentAllService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient,
    private authService: AuthService
  ) { }

  getEstablishments(NavigateEstablishmentRequest: NavigateEstablishment) {

    if (this.authService.isLoggedIn()) {
      // console.log('token',this.authService.getToken());

      const tokenUser = this.authService.getToken();
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${tokenUser}`,
        'Content-Type': 'application/json'
      });
      return this.http.post<EstablishmentsForCategorieResponse>(`${this.apiUrl}/establishmentForLocation`, NavigateEstablishmentRequest,{headers}).pipe(shareReplay(1));
    }
 return this.http.post<EstablishmentsForCategorieResponse>(`${this.apiUrl}/establishmentForLocation`, NavigateEstablishmentRequest).pipe(shareReplay(1));
  }
}
